module.exports = __webpack_public_path__ + "static/media/AI_Question_Icon.96309f01.svg";